<template>
  <div>
    <el-dialog
      :title="$route.query.type === 'edit'? $t('payment_links.edit_payment_link') : $t('payment_links.create_payment_link')"
      :visible.sync="dialogVisible"
      width="739px"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <div class="title">
        {{ $route.query.type === 'edit'? $t('payment_links.update_successful_tips') : $t('payment_links.create_successful_tips') }}
      </div>
      <div style="width: fit-content;margin: 0 auto;">
        <el-input v-model.trim="form.link_url" :placeholder="$t('payment_links.link_no')" class="from-input" size="small" type="text" clearable />
        <el-button type="info" size="small" class="copy-text" :data-clipboard-text="form.link_url " @click="onClickCopyBtn('.copy-text','Link')">{{ $t('payment_links.copy_link') }}</el-button>
      </div>
      <div class="img">
        <img :src="form.link_qr_base64" alt="">
      </div>
      <div class="dialog-footer">
        <el-button class="btn-download" type="primary" size="small" @click="onClickDownloadBtn">{{ $t('payment_links.download_qr_code') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { download } from '@/utils/common'
import Clipboard from 'clipboard'
export default {
  name: 'CreateSuccessful',
  components: { },
  data() {
    return {
      dialogVisible: false, // 控制弹框显示隐藏
      submitLoading: false,
      downloading: false,
      form: {}
    }
  },
  methods: {
    // 改变弹框状态
    changModalStatus(value, data) {
      this.form = data
      this.dialogVisible = value
    },
    onClickCopyBtn(selectClass, name) {
      const btnCopy = new Clipboard(selectClass)
      btnCopy.on('success', () => {
        this.$message.success(`Copy ${name} Successfully!`)
        btnCopy.destroy()
      })
      btnCopy.on('error', function(e) {
        btnCopy.destroy()
      })
    },
    onClickDownloadBtn() {
      const img = this.form.link_qr_base64
      const name = 'QR_Code_' + this.form.link_no
      if (!img) {
        return
      }
      if (this.downloading) {
        return
      }
      this.downloading = true
      download(img, name)
      setTimeout(() => {
        this.downloading = false
      }, 5000)
    },
    closeDialog() {
      this.$router.push('/paymentLink/list')
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog__header{
  padding: 12px 24px;
  height: 48px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.20);
  .el-dialog__headerbtn{
    top: 16px;
  }
  span{
    color: #1B4AEF;
    font-size: 16px;
    font-family: Inter;
    font-weight: 600;
  }
}
::v-deep .el-dialog__body{
  padding: 24px;
}
.title{
  color: #1D3A71;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  padding: 0 0 12px;
}
.from-input{
  width: 300px;
  margin-right: 10px;
}
.img{
  margin: 12px auto;
  width: 245px;
  text-align: center;
  img{
    width: 100%;
  }
}
.dialog-footer{
  margin: 0 auto;
  width: fit-content;
  .btn-download{
    width: 245px;
  }
}
</style>
